import * as React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

type AuthGuardProps = {
	isLoggedIn: boolean;
};

const AuthGuard = ({ isLoggedIn }: AuthGuardProps) => {
	return isLoggedIn ? <Outlet /> : <Navigate to='/login' />;
};
export default AuthGuard;
